import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const paymentSettingsApi = createApi({
    reducerPath: "paymentSettingsApi",
    tagTypes: ["paymentSettings"],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: (build) => ({
        getPaymentSettings: build.query({
            query: (data) => ({
                url: api.paymentSettings.getPaymentSettings(data.settingable_id),
                method: "GET",
                params: data,
            }),
            providesTags: ["paymentSettings"],
        }),
        updatePaymentSettings: build.mutation({
            query: (settings) => ({
                url: api.paymentSettings.updatePaymentSettings(),
                method: "POST",
                body: settings,
            }),
            invalidatesTags: ["paymentSettings"],
        }),
    }),
});

export const {
    useLazyGetPaymentSettingsQuery, useGetPaymentSettingsQuery, useUpdatePaymentSettingsMutation
} = paymentSettingsApi;
